
import { Vue, Component, Prop } from "vue-property-decorator";
import { DateFormatterHelper } from "@directives/base/date-formatter";

@Component({
  name: "ci-price-update-box",
})
export default class extends Vue {
  @Prop({ default: () => null }) public timestamp!: Nullable<string>;
  @Prop({ default: () => true }) public styling!: boolean;
  @Prop({ default: () => false }) public upToDate!: boolean;
  @Prop({ default: () => "" }) public prefix!: boolean;

  public get value(): string {
    const { parse } = DateFormatterHelper;
    const element = document.createElement("span") as HTMLElement;
    const dateString = parse({ value: this.timestamp }, element);

    return this.prefix + dateString;
  }

  public get outdated(): string {
    if (!this.upToDate && this.styling) {
      return "text-danger";
    }
    return "text-muted";
  }
}
